import type { IconProps } from '../types/IconProps.ts';
export const HeartCrack: IconProps = {
    name: 'HeartCrack',
    children: [
        `<path d="m11.96 7.7-1.19-1.28a5.07 5.07 0 1 0-7.06 7.25l8.1 7.16c.1.1.27.1.38 0l8.1-7.16a5.07 5.07 0 1 0-7.06-7.25L12.04 7.7z" />`,
        `<path d="m12 8-1 1.98.02.03 1.96.98v.03l-1.97 1.97V13L13 15" />`,
    ]
};